<div>
    <data-table :headings="orderItemsHeadings"
                :data="orderItems"
                :hasActions="false"
                :pagingDetails="pagingDetails"
                :hasNoFilter="true">
        <template #content>
            <div class="float-right">
                <b>Grand Total: {{grandTotal}}</b>
            </div>
        </template>
    </data-table>
</div>